import React, { useEffect, useState } from 'react'
import { useBlocker } from 'react-router'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { FieldNamesMarkedBoolean } from 'react-hook-form'
import { FormWarrantEntity } from '../../pages/admin/types/FormWarrantEntity'

type LeavePageConfirmationDialogComponent = React.FC<{
    isDirty: boolean
    dirtyFields?: FieldNamesMarkedBoolean<FormWarrantEntity>
}>

export const LeavePageConfirmationDialog: LeavePageConfirmationDialogComponent = ({ dirtyFields, isDirty = false }) => {
    const [navigateConfirmModal, setNavigateConfirmModal] = useState(false)

    useEffect(() => {
        const handleBeforeUnload = (e: Event) => {
            if (isDirty) {
                e.preventDefault()
                return true // Return a truthy value
            }
            return null // Allow navigation if no conditions met
        }

        window.addEventListener('beforeunload', handleBeforeUnload)

        return () => window.removeEventListener('beforeunload', handleBeforeUnload)
    }, [isDirty])

    const shouldBlockNavigation = ({
        currentLocation,
        nextLocation,
    }: {
        currentLocation: { pathname: string }
        nextLocation: { pathname: string }
    }) => {
        if (currentLocation.pathname === nextLocation.pathname) {
            return false
        }
        if (isDirty) {
            setNavigateConfirmModal(true)
            return true
        }
        return false
    }

    const blocker = useBlocker(shouldBlockNavigation)

    if (!navigateConfirmModal) return null
    return (
        <Dialog open={true}>
            <DialogTitle>Ändringar ej sparade</DialogTitle>
            <DialogContent>
                Är du säker på att du vill lämna? Du har osparade ändringar.
                {dirtyFields && (
                    <>
                        <p>Ändrade fält:</p>
                        <pre>{JSON.stringify(dirtyFields, null, 2)}</pre>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        setNavigateConfirmModal(false)
                    }}
                >
                    Avbryt
                </Button>
                <Button
                    onClick={() => {
                        if (blocker?.proceed) {
                            blocker.proceed()
                        }
                    }}
                >
                    Fortsätt
                </Button>
            </DialogActions>
        </Dialog>
    )
}
